import { render, staticRenderFns } from "./ApprovePass.vue?vue&type=template&id=01b8beba&scoped=true&"
import script from "./ApprovePass.ts?vue&type=script&lang=ts&"
export * from "./ApprovePass.ts?vue&type=script&lang=ts&"
import style0 from "./ApprovePass.vue?vue&type=style&index=0&id=01b8beba&prod&scoped=true&lang=scss&"
import style1 from "./ApprovePass.vue?vue&type=style&index=1&id=01b8beba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b8beba",
  null
  
)

export default component.exports